import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/site/Reveal";

export default function Blog({ posts }) {
  if (!posts || posts.length === 0) return null;
  return (
    <section id="news" data-testid="news-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <SectionHeading kicker="Press & News" title="The Royal Chronicle" testid="news-heading" />
      <div className="grid gap-10 md:grid-cols-2">
        {posts.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.12}>
            <article data-testid={`news-card-${i}`} className="group border border-white/10 bg-[#0C0C0C] transition-colors duration-500 hover:border-[#D4AF37]/50">
              <div className="overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="h-72 w-full bg-black object-contain transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-8">
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/80">
                  {p.created_at ? new Date(p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : "News"}
                </span>
                <h3 data-testid={`news-title-${i}`} className="font-display mt-3 text-2xl font-medium leading-snug text-white md:text-3xl">
                  {p.title}
                </h3>
                <p className="mt-4 text-sm font-light leading-relaxed text-neutral-400">{p.excerpt}</p>
                <Link
                  to={`/news/${p.id}`}
                  data-testid={`news-read-more-${i}`}
                  className="mt-6 inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-[#D4AF37] transition-all duration-300 hover:gap-5"
                >
                  Read the Story <ArrowRight className="h-4 w-4" strokeWidth={1} />
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
